export default __webpack_public_path__ + "static/media/GitbookIcon.3ca27524.svg";